import AutomationError from './AutomationError';
class DoesNotHaveFiscalZipCode extends AutomationError {
    constructor(options) {
        super('The investor does not have fiscal zip code configured.', options);
    }
}
export default DoesNotHaveFiscalZipCode;
